import { useAppStore } from '../stores/appStore'
import { normalizeAssetUrl } from '../config'

// Map /media/.../file.ext -> /media/{res}/.../file.ext
export const rewriteTextureUrl = (url: string, res: '1k'|'2k'|'4k'): string => {
  try {
    if (!url) return url
    const u = new URL(url, window.location.origin)
    if (!u.pathname.startsWith('/media/')) return normalizeAssetUrl(url)
    const rest = u.pathname.slice('/media/'.length)
    u.pathname = `/media/${res}/${rest}`
    return normalizeAssetUrl(u.toString())
  } catch {
    // Relative path or invalid URL; fallback naive replace
    if (url.startsWith('/media/')) {
      const rewritten = url.replace('/media/', `/media/${res}/`)
      return normalizeAssetUrl(rewritten)
    }
    return normalizeAssetUrl(url)
  }
}

// Attempt HEAD then fallback to lower res then original
export const resolveTextureUrl = async (url: string, preferRes?: '1k'|'2k'|'4k'): Promise<string> => {
  const res = preferRes || useAppStore.getState().textureResolution || '1k'
  const order: Array<'1k'|'2k'|'4k'> = res === '4k' ? ['4k','2k','1k'] : res === '2k' ? ['2k','1k'] : ['1k']
  for (const r of order) {
    const candidate = rewriteTextureUrl(url, r)
    try {
      const resp = await fetch(candidate, { method: 'HEAD', mode: 'cors' as any })
      if (resp.ok) return candidate
    } catch {}
  }
  return url
}



